<template>
    <div>
        <Input type="search" :name="tableId" :placeholder="placeholder" :modelValue="searchVal" class="w-full" @input="filter" />
    </div>
</template>

<script>
import Input from '@/Components/Input.vue'

import store from '@/store'
import { Inertia } from "@inertiajs/inertia"
import { ref, onMounted, watch } from 'vue'

export default {
    components: {
        Input,
    },
    props: {
        values: {
            type: [Array, Object],
            required: true
        },
        tableId: { //Unique id for the table
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const urlQueryString = window.location.search
        const urlParams = new URLSearchParams(urlQueryString);
        let searchVal = ref('');
        let columnIds = []

        store.changeCurrentSearch({search: '', id: store.state.currentTableId})

        if (urlParams.has('search'))
        {
            searchVal.value = urlParams.get('search')
            store.changeCurrentSearch({search: urlParams.get('search'), id: store.state.currentTableId})
        }

        onMounted(() => {

            if (store.state.side[props.tableId] == 'client')
            {
                //Get table columns where we can perform a search on
                const columns = document.querySelectorAll('#' + props.tableId + ' th')

                columns.forEach(function (column)
                {
                    if (column.id && column.dataset.search === 'true')
                    {
                        columnIds.push(column.id)
                    }
                })
            }
        })

        //search filter
        function filter(event)
        {
            //We need to know for which table we are doing the search
            store.changeTableId({id: props.tableId})

            if (store.state.side[props.tableId] == 'client')
            {
                let filteredValues = props.values.filter(row => {

                    let searchFound = false

                    //Loop through all table rows and check if is has our search value
                    columnIds.forEach(function (columnId)
                    {
                        const column = columnId.split('.')//for relational columns
                        let record = row

                        //To check the data in the relational column (e.g. unit.name)
                        if (column.length > 1)
                        {
                            column.forEach(function(columnPart)
                            {
                                if (record !== null && record.hasOwnProperty(columnPart))
                                {
                                    record = (record[columnPart] !== null) ? record[columnPart] : null;
                                }
                            });
                        }
                        else
                        {
                            record = row[column]
                        }

                        //Check if we found a match in the column with the search term
                        if (record && record.toString().toLowerCase().includes(event.target.value.toString().toLowerCase()))
                        {
                            searchFound = true
                        }
                    })

                    return searchFound
                })

                store.changeAllValues({values: filteredValues, id: props.tableId})
            }
            else
            {
                //Server side search
                Inertia.get(
                    window.location.href,
                    {
                        search: event.target.value,
                        column: store.state.currentCol[store.state.currentTableId],
                        direction: store.state.currentDir[store.state.currentTableId],
                        page: 1,
                    },
                    {
                        // replace: true,
                        preserveState: true,
                        onSuccess: () => {
                            // if (store.state.side[props.tableId] == 'client')
                            // {
                                store.changeAllValues({values: props.values, id: props.tableId})
                            // }
                            // else {
                                //server side
                                // store.changeAllValues({values: props.values.data, id: props.tableId})
                            // }

                            store.changeCurrentSearch({search: event.target.value, id: props.tableId})
                        },
                    }
                )
            }

        }

        return {
            state: store.state,
            ...store,
            searchVal,
            filter
        }
    }
}

</script>
